import {gql} from "@apollo/client";

export const GET_DEPOSIT_LIMITS = gql`
          query GetDepositLimits {
                   limits (where: { and: [
                     {status : {in:[ACTIVE,QUEUED]}}
                     {type :{ eq : DEPOSIT}}
                   ]}) {
                     nodes {
                       id
                       period
                       value
                       currentAmount
                       status
                       start,
                       requiresApproval,
                       approved
                     }
                   }
                 
          }`;
